<div
    bsModal
    #createOrEditModal="bs-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createOrEditModal"
    aria-hidden="true"
    [config]="{ backdrop: 'static' }"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #priceGroupForm="ngForm" novalidate (ngSubmit)="save()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span *ngIf="priceGroup.id">{{ l('EditPriceGroup') }}</span>

                        <span *ngIf="!priceGroup.id">{{ l('CreateNewPriceGroup') }}</span>
                    </h4>

                    <button
                        type="button"
                        class="btn-close"
                        (click)="close()"
                        aria-label="Close"
                        [disabled]="saving"
                    ></button>
                </div>
                <div class="modal-body">
                    <div class="my-3">
                        <label class="form-label" for="PriceGroup_Name">{{ l('Name') }} *</label>
                        <input
                            type="text"
                            #PriceGroup_Name="ngModel"
                            id="PriceGroup_Name"
                            class="form-control"
                            [(ngModel)]="priceGroup.name"
                            name="Name"
                            required
                        />
                        <validation-messages [formCtrl]="PriceGroup_Name"></validation-messages>
                    </div>

                    <div class="my-3">
                        <label class="form-label" for="PriceGroup_Description">{{ l('Description') }}</label>
                        <textarea 
                            type="text"
                            rows="3"
                            #PriceGroup_Description="ngModel"
                            id="PriceGroup_Description"
                            class="form-control"
                            [(ngModel)]="priceGroup.description"
                            name="Description">

                        </textarea>
                        <validation-messages [formCtrl]="PriceGroup_Description"></validation-messages>
                    </div>

                    <div class="my5">
                        <label class="form-label" for="PriceGroup_Discount">{{ l('Discount') }}</label>
                        <input
                            type="number"
                            #PriceGroup_Discount="ngModel"
                            id="PriceGroup_Discount"
                            class="form-control"
                            [(ngModel)]="priceGroup.discount"
                            name="Discount"
                        />
                        <validation-messages [formCtrl]="PriceGroup_Discount"></validation-messages>
                    </div>
                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-default" (click)="close()">
                        {{ l('Cancel') }}
                    </button>
                    <button
                        type="submit"
                        class="btn btn-primary blue"
                        [disabled]="!priceGroupForm.form.valid"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
